import { useAuth } from "../context/AuthContext";
import { useData } from "../context/DataContext";

export const useHierarchy = () => {
  const { currentUser } = useAuth();
  const { users } = useData();

  const canManageUser = (targetUserId: string | number | undefined) => {
    if (!targetUserId || !currentUser) return false;

    // User ID is often an object in the DataContext, so we normalize
    const targetIdStr = targetUserId.toString();
    const currentUserIdStr = currentUser.id.toString();

    // Admin and Director can manage everyone
    if (currentUser.userRole === 'Admin' || currentUser.userRole === 'Director') return true;

    // User can manage themselves
    if (targetIdStr === currentUserIdStr) return true;

    // Recursive check for management chain
    let currentCheckId: string | undefined = targetIdStr;
    const seen = new Set<string>();

    while (currentCheckId && !seen.has(currentCheckId)) {
      seen.add(currentCheckId);
      const u = users.find(user => user.id.toString() === currentCheckId);
      if (!u || !u.manager) break;

      // manager can be an object {id: ...} or a direct ID
      const managerId = typeof u.manager === 'object' ? (u.manager as any).id : u.manager;
      const managerIdStr = managerId?.toString();

      if (managerIdStr === currentUserIdStr) return true;

      currentCheckId = managerIdStr;
    }

    return false;
  };

  return { canManageUser };
};
